import { Controller } from "@hotwired/stimulus"

// Track the currently open tooltip so only one is open at a time
let activeTooltip = null

export default class extends Controller {
  static targets = ["tooltip"]
  static values = { column: Number }

  connect() {
    this.isOpen = false
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
    if (activeTooltip === this) activeTooltip = null
    this.stopAudio()
  }

  toggle(event) {
    event.stopPropagation()
    if (this.isOpen) {
      this.doHide()
    } else {
      // Close any other open tooltip first
      if (activeTooltip && activeTooltip !== this) {
        activeTooltip.doHide()
      }
      this.doShow()
    }
  }

  doShow() {
    if (this.hasTooltipTarget) {
      this.isOpen = true
      activeTooltip = this
      this.element.style.zIndex = "100"
      this.tooltipTarget.classList.remove("hidden")

      // Adjust positioning for edge columns to prevent overflow
      if (this.hasColumnValue) {
        if (this.columnValue === 0) {
          // First column - align left edge
          this.tooltipTarget.style.left = "0"
          this.tooltipTarget.style.transform = "none"
        } else if (this.columnValue === 4) {
          // Last column - align right edge
          this.tooltipTarget.style.left = "auto"
          this.tooltipTarget.style.right = "0"
          this.tooltipTarget.style.transform = "none"
        }
      }
    }
  }

  doHide() {
    if (this.hasTooltipTarget) {
      this.isOpen = false
      if (activeTooltip === this) activeTooltip = null
      this.stopAudio()
      this.tooltipTarget.classList.add("hidden")
      this.element.style.zIndex = ""

      // Reset positioning
      if (this.hasColumnValue && (this.columnValue === 0 || this.columnValue === 4)) {
        this.tooltipTarget.style.left = "50%"
        this.tooltipTarget.style.right = ""
        this.tooltipTarget.style.transform = "translateX(-50%)"
      }
    }
  }

  stopAudio() {
    // Find and stop any audio players inside the tooltip
    if (this.hasTooltipTarget) {
      const audioButtons = this.tooltipTarget.querySelectorAll("[data-controller='audio-player']")
      audioButtons.forEach(btn => {
        btn.dispatchEvent(new CustomEvent("audio:stop"))
      })
    }
  }

  handleClickOutside(event) {
    if (this.isOpen && !this.element.contains(event.target)) {
      this.doHide()
    }
  }
}
